export default "__VITE_ASSET__e9165b08__"